import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import styles from "./rectangle-label.module.scss";
import classNames from "classnames";

export class RectangleLabelComponentProps extends BaseProps {
  className: String;
  colorLabelClassName: String;
  isSmallView: Boolean;
  isVisible: Boolean;
}

export const RectangleLabel = ({device, className, colorLabelClassName, isVisible, children}: RectangleLabelComponentProps) => {
  const containerProps = {
    className: classNames(
      className,
      styles.container,
      {[styles.small_view]: device?.isSmallView},
      colorLabelClassName
    )
  }

  return (
    isVisible && <div {...containerProps}>
      {children}
    </div>
  )
}
